import { Injectable } from '@angular/core';
import { BaseResultModel } from '../models/base-result.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  public showSuccessMessage(message: string): void {
    this.addSuccessBanner(message);
  }

  public showErrorMessage(message: string): void {
    this.addErrorBanner(message);
  }

  public showMessage(result: BaseResultModel): void {
    if (!result.Message) {
      return;
    }

    if (result.Success) {
      this.showSuccessMessage(result.Message);
    } else {
      this.showErrorMessage(result.Message);
    }
  }

  private addSuccessBanner(message: string) {
    if (message) {
      const el = this.createElement('<div class="alert alert-success" role="alert">' + message + '</div >');
      document.getElementById('notificationContainer')?.append(el);
      this.notificationTimer(el);
    }
  }

  private addErrorBanner(message: string) {
    if (message) {
      const el = this.createElement('<div class="alert alert-primary" role="alert">' + message + '</div >');
      document.getElementById('notificationContainer')?.append(el);
      this.notificationTimer(el);
    }
  }

  private createElement(html: string) {
    const t = document.createElement('template');
    t.innerHTML = html;
    return t.content.children[0];
  }

  private notificationTimer(element: Element) {
    setTimeout(function () {
      element.remove();
    }, 10000);
  }

}
